export default "__VITE_PUBLIC_ASSET__d06dedae__"